module.exports = __webpack_public_path__ + "5eab4a1e4a865705841f397fa647fc70.png";